import React, { useState, useEffect } from "react";
import { styles } from "./styles";
import { withStyles, Drawer, Grid, Divider } from "@material-ui/core";
import Menu from "@jll/menu";
import Typography from "@material-ui/core/Typography";
import { NavLink } from "react-router-dom";
import { recordTypes } from "../../../../API/config";
import { formatDate, getAttributeValue } from "../../../../Utilities/Functions";
import Icon from "@jll/icon";
import { LightTooltip } from "../../../../Component";
import { useTranslation } from "react-i18next";

const RecordSideBar = (props) => {
  const { classes, entity, entityId, hasRecordPermission } = props;
  const { attributes = [], checkRequests = [], confidential } = entity || {};
  const { t } = useTranslation();

  const [canViewKycFields, setCanViewKycFields] = useState();
  const [canViewAmlFields, setCanViewAmlFields] = useState();
  const [canViewRelatedEntities, setCanViewRelatedEntities] = useState();
  const [canViewAuditRecords, setCanViewAuditRecords] = useState();
  const [canViewClientDocumentRequests, setCanViewClientDocumentRequests] =
    useState();

  useEffect(() => {
    const setPermissions = async () => {
      const { permissions = {}, confidential } = entity || {};
      const canViewKycFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewKycFields.name,
      );
      setCanViewKycFields(canViewKycFields);
      const canViewAmlFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAmlFields.name,
      );
      setCanViewAmlFields(canViewAmlFields);
      const canViewRelatedEntities = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewRelatedEntities.name,
      );

      const canViewSensitiveFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewSensitiveFields.name,
      );

      setCanViewRelatedEntities(
        (!confidential || canViewSensitiveFields) && canViewRelatedEntities,
      );

      const canViewAuditRecords = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAuditRecords.name,
      );

      setCanViewAuditRecords(canViewAuditRecords);

      const canViewClientDocumentRequests = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewClientDocumentRequests.name,
      );

      setCanViewClientDocumentRequests(canViewClientDocumentRequests);
    };

    setPermissions();
  }, [entity]);

  const titleAttr = attributes.find((a) => a.id === "3");
  const companyTitle = getAttributeValue(titleAttr) || "";

  const renderTooltopData = () => {
    return (
      <div>
        <Grid container>
          <Grid item xs={4} container justify="flex-start">
            <Typography component="span" className={classes.headerTitle}>
              {t("labels.record.summary.recordName")}
            </Typography>
          </Grid>
          <Grid item xs={8} container justify="flex-start">
            <Typography component="span" className={classes.headerText}>
              {companyTitle}
            </Typography>
          </Grid>
        </Grid>
        {checkRequests.map((eachRequest, index) => (
          <div key={index}>
            <hr />
            <Grid container>
              <Grid item xs={4} container justify="flex-start">
                <Typography component="span" className={classes.headerTitle}>
                  {t("labels.record.summary.checkId")}
                </Typography>
              </Grid>
              <Grid item xs={8} container justify="flex-start">
                <Typography component="span" className={classes.headerText}>
                  {eachRequest.id}
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid container>
                <Grid item xs={4} container justify="flex-start">
                  <Typography component="span" className={classes.headerTitle}>
                    {t("labels.record.summary.createdDate")}
                  </Typography>
                </Grid>
                <Grid item xs={8} container justify="flex-start">
                  <Typography component="span" className={classes.headerText}>
                    {formatDate(eachRequest.created_date)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4} container justify="flex-start">
                  <Typography component="span" className={classes.headerTitle}>
                    {t("labels.record.summary.checkType")}
                  </Typography>
                </Grid>
                <Grid item xs={8} container justify="flex-start">
                  <Typography component="span" className={classes.headerText}>
                    {eachRequest.check_type}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={4} container justify="flex-start">
                  <Typography component="span" className={classes.headerTitle}>
                    {t("labels.record.summary.workflowState")}
                  </Typography>
                </Grid>
                <Grid item xs={8} container justify="flex-start">
                  <Typography component="span" className={classes.headerText}>
                    {eachRequest.process_flow_state}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4} container justify="flex-start">
                  <Typography component="span" className={classes.headerTitle}>
                    {t("labels.record.summary.jllCountry")}
                  </Typography>
                </Grid>
                <Grid item xs={8} container justify="flex-start">
                  <Typography component="span" className={classes.headerText}>
                    {eachRequest.name}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4} container justify="flex-start">
                  <Typography component="span" className={classes.headerTitle}>
                    {t("labels.record.summary.requestor")}
                  </Typography>
                </Grid>
                <Grid item xs={8} container justify="flex-start">
                  <Typography component="span" className={classes.headerText}>
                    {eachRequest.created_by_user_name}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4} container justify="flex-start">
                  <Typography component="span" className={classes.headerTitle}>
                    {t("labels.record.summary.assigned")}
                  </Typography>
                </Grid>
                <Grid item xs={8} container justify="flex-start">
                  <Typography component="span" className={classes.headerText}>
                    {eachRequest.allocated_user_name
                      ? eachRequest.allocated_user_name
                      : "labels.record.summary.unassigned"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <div className={classes.headerContainer}>
        <Typography component="span" className={classes.hTStyle1}>
          <Icon className="far fa-university" style={{ marginRight: 5 }} />
          {companyTitle}
        </Typography>

        {confidential && (
          <Typography component="span" className={classes.headerText}>
            {t("labels.record.summary.confidential")}
          </Typography>
        )}

        <LightTooltip
          title={renderTooltopData()}
          style={{ paddingBottom: 0, paddingTop: 0 }}
        >
          <Typography
            component="span"
            className={classes.headerTitle}
            style={{ color: "#898B8E" }}
          >
            {t("labels.record.summary.checkRequest")}&nbsp;
            <Icon
              className="far fa-question-circle"
              style={{ marginRight: 5 }}
            />
          </Typography>
        </LightTooltip>
      </div>
      <Divider />
      <Menu>
        <NavLink
          to={`/basicinfo?id=` + entityId}
          className={classes.menuItem}
          activeClassName={classes.menuItemActive}
        >
          {t("labels.record.sections.basicInfo")}
        </NavLink>
        {canViewKycFields && (
          <NavLink
            to={`/financials?id=` + entityId}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.record.sections.financials")}
          </NavLink>
        )}
        {canViewKycFields && (
          <NavLink
            to={`/kyc?id=` + entityId}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.record.sections.kyc")}
          </NavLink>
        )}
        {canViewAmlFields && (
          <NavLink
            to={`/aml?id=` + entityId}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.record.sections.aml")}
          </NavLink>
        )}
        {canViewRelatedEntities && (
          <NavLink
            to={`/relatedEntities?id=` + entityId}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.record.sections.relatedEntities")}
          </NavLink>
        )}
        {canViewAmlFields && (
          <NavLink
            to={`/orgStructure?id=` + entityId}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.record.sections.ownershipStructure")}
          </NavLink>
        )}
        {canViewClientDocumentRequests && (
          <NavLink
            to={`/documentRequests?id=` + entityId}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.record.sections.requestDocuments")}
          </NavLink>
        )}
        {canViewAuditRecords && (
          <NavLink
            to={`/audit?id=` + entityId}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.admin.auditRecords")}
          </NavLink>
        )}

        {/*  {canViewProfitAndLoss && <NavLink
            to={"/does-not-exist"}
            onClick={(e) => e.preventDefault()}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            P&amp;L
          </NavLink>}
          {canViewBalanceSheet && <NavLink
            to={"/does-not-exist"}
            onClick={(e) => e.preventDefault()}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            Balance Sheet
          </NavLink>} */}
      </Menu>
    </Drawer>
  );
};

export default withStyles(styles, { withTheme: true })(RecordSideBar);
